module.exports = __webpack_public_path__ + "static/media/CTLA_8-475w.9f38cb60.webp";